import React from 'react';
import { Card } from 'react-bootstrap';
import { FaKey } from 'react-icons/fa';
import { toast } from 'react-toastify';
import CopyableField from './CopyableField';
import PasswordField from './PasswordField';
import FavoritesStar from './FavoritesStar';

const UserInfoCard = ({ data, isFavorito, onToggleFavorito, podeVerSenhaAprovacao }) => {
  if (!data) return null;

  const isUser = data.is_user;

  const copiarSenha = (senha, ambiente) => {
    if (!senha) return;
    navigator.clipboard.writeText(senha).then(() => {
      toast.success('Senha ' + ambiente + ' copiada!', { autoClose: 1500 });
    });
  };

  const senhas = [
    { valor: data.senha_dev, cor: '#28a745', nome: 'Dev' },
    { valor: data.senha_hml, cor: '#ffc107', nome: 'Tre' },
    { valor: data.senha_prod, cor: '#dc3545', nome: 'Pro' },
  ];

  return (
    <Card
      className="mt-3 user-info-card"
      style={{
        maxWidth: '100%',
        width: '100%',
        borderRadius: '12px',
        border: 'none',
        boxShadow: '0 1px 8px rgba(0,0,0,0.05)',
      }}
    >
      <style>{`
        .password-field-row {
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .password-field-label {
          width: 150px;
          flex-shrink: 0;
        }
        .user-info-block {
          background-color: #f8fafc;
          border-radius: 10px;
          padding: 4px 14px;
          margin-bottom: 12px;
        }
        .user-info-row {
          display: flex;
          align-items: baseline;
          gap: 10px;
          padding: 6px 0;
          border-bottom: 1px solid #eef1f5;
        }
        .user-info-row:last-child {
          border-bottom: none;
        }
        .user-info-label {
          font-size: 0.72rem;
          text-transform: uppercase;
          color: #8895a7;
          font-weight: 600;
          letter-spacing: 0.3px;
          flex-shrink: 0;
          min-width: 110px;
        }
        .user-info-value {
          font-weight: 600;
          color: #1a2332;
          font-size: 0.88rem;
          flex: 1;
          overflow-wrap: anywhere;
        }
        @media (max-width: 768px) {
          .password-field-row {
            flex-direction: column;
            align-items: flex-start;
            gap: 4px;
          }
          .password-field-controls {
            width: 100%;
          }
          .password-field-controls .form-control {
            max-width: 100% !important;
            flex: 1;
          }
          .detail-modal-body {
            padding: 0 !important;
          }
          .detail-modal-body .user-info-card {
            border: none !important;
            box-shadow: none !important;
            margin: 0 !important;
          }
          .user-info-label {
            min-width: 90px;
          }
        }
      `}</style>
      <Card.Body>
        {onToggleFavorito && (
          <div className="d-flex justify-content-end mb-2">
            <FavoritesStar
              identificador={data.identificador}
              isUser={data.is_user}
              isFavorito={!!isFavorito}
              onToggle={onToggleFavorito}
            />
          </div>
        )}
        {isUser ? (
          <>
            <div className="user-info-block">
              <div className="user-info-row">
                <span className="user-info-label">Código</span>
                <span className="user-info-value">{data.codigo}</span>
              </div>
              <div className="user-info-row">
                <span className="user-info-label">Nome</span>
                <span className="user-info-value">{data.nome}</span>
              </div>
              {data.tem_departamento && (
                <div className="user-info-row">
                  <span className="user-info-label">Departamento</span>
                  <span className="user-info-value">
                    {data.codigo_departamento} - {data.departamento}
                  </span>
                </div>
              )}
              {data.tem_grupo && (
                <div className="user-info-row">
                  <span className="user-info-label">Grupo</span>
                  <span className="user-info-value">
                    {data.codigo_grupo} - {data.nome_grupo}
                    {data.is_corretor_desligado && (
                      <span className="text-danger ml-2">(inativo(a))</span>
                    )}
                  </span>
                </div>
              )}
            </div>

            <div style={{ borderTop: '1px solid #eef1f5', margin: '12px 0' }} />

            <div style={{ borderLeft: '3px solid #0747a6', paddingLeft: '14px', marginBottom: '16px' }}>
              <CopyableField label="Login" value={data.nome_usuario} />
              <div className="d-flex align-items-center mt-1" style={{ gap: '10px' }}>
                {senhas.map((s) => (
                  <FaKey
                    key={s.nome}
                    style={{
                      color: s.valor ? s.cor : '#ddd',
                      cursor: s.valor ? 'pointer' : 'default',
                      fontSize: '15px',
                      transition: 'transform 0.15s ease',
                    }}
                    title={s.valor ? 'Copiar senha ' + s.nome : 'Indisponível'}
                    onClick={() => copiarSenha(s.valor, s.nome)}
                  />
                ))}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="user-info-block">
              <div className="user-info-row">
                <span className="user-info-label">GE</span>
                <span className="user-info-value">{data.ge}</span>
              </div>
              <div className="user-info-row">
                <span className="user-info-label">Conta</span>
                <span className="user-info-value">{data.conta}</span>
              </div>
              <div className="user-info-row">
                <span className="user-info-label">Razão Social</span>
                <span className="user-info-value">{data.nome}</span>
              </div>
            </div>

            <div style={{ borderTop: '1px solid #eef1f5', margin: '12px 0' }} />

            <div style={{ borderLeft: '3px solid #0747a6', paddingLeft: '14px', marginBottom: '16px' }}>
              <CopyableField label="CPF/CNPJ" value={data.nome_usuario} />
              <div className="d-flex align-items-center mt-1" style={{ gap: '10px' }}>
                {senhas.map((s) => (
                  <FaKey
                    key={s.nome}
                    style={{
                      color: s.valor ? s.cor : '#ddd',
                      cursor: s.valor ? 'pointer' : 'default',
                      fontSize: '15px',
                      transition: 'transform 0.15s ease',
                    }}
                    title={s.valor ? 'Copiar senha ' + s.nome : 'Indisponível'}
                    onClick={() => copiarSenha(s.valor, s.nome)}
                  />
                ))}
              </div>
            </div>
          </>
        )}

        <div style={{
          backgroundColor: '#f8fafc',
          borderRadius: '10px',
          padding: '14px',
          marginTop: '4px',
        }}>
          <div style={{
            fontSize: '0.78rem',
            fontWeight: 600,
            color: '#0747a6',
            marginBottom: '10px',
            textTransform: 'uppercase',
            letterSpacing: '0.3px',
          }}>
            Senhas de Acesso
          </div>
          <PasswordField
            label="Desenvolvimento"
            value={data.senha_dev}
            available={data.tem_senha_dev}
            color="#28a745"
          />
          <PasswordField
            label="Homologação"
            value={data.senha_hml}
            available={data.tem_senha_hml}
            color="#ffc107"
          />
          <PasswordField
            label="Produção"
            value={data.senha_prod}
            available={data.tem_senha_prod}
            color="#dc3545"
          />
          {podeVerSenhaAprovacao && isUser && (
            <PasswordField
              label="Aprovação"
              value={data.senha_aprovacao}
              available={data.tem_senha_aprovacao}
              color="#6f42c1"
            />
          )}
        </div>

        {data.email && (
          <div className="mt-3">
            <CopyableField label="Email" value={data.email} />
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default UserInfoCard;
